module.exports = __webpack_public_path__ + "static/05-ac7c9f2ee1cddc7b065cd4195d87d60c.jpg";